import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { useQuery } from "react-query";
import { Asset } from "../../shared/interfaces/Asset";

export function useSwitchgearsBySubstation(substationId?: number | string, callbacks?: QueryCallbacks<Asset[]>) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["switchgearsByHVSubstation", substationId],
    queryFn: async () => {
      if (substationId) return await apiContext.assetApis.getSwitchgearsByHVSubstation(substationId);
    },
    onSuccess: callbacks?.onSuccess,
    onError: callbacks?.onError,
  });
}
